
<template>
<v-card class="transparent" flat width="100%" height="100%" style="padding-bottom:50px;">

    <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
      <span>Awesome! You updated the Article.</span>
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-layout justify-center>
    <v-flex xs12 s12 m10 lg10>
    <v-card-title class="title font-weight-regular justify-space-between">
          <span>Edit Article</span>
          <v-avatar
            size="45"
          >
          <v-img  v-if="UserRecord.Profile_Photo" :src="UserRecord.Profile_Photo">
          </v-img>
          <v-img v-if="!UserRecord.Profile_Photo" src="@/assets/BlankProfilePic.png">
          </v-img>
          </v-avatar>
        </v-card-title>
        <v-card-subtitle>
          {{UserRecord.Full_Name}}
        </v-card-subtitle>
        <v-layout class="justify-center">
        <v-card flat outlined light width="90%" class="my-3">
            <v-card-text>
                <v-text-field label="Title" v-model="ArticleTitle">
                </v-text-field>     
                <v-combobox return-object item-text="Name"
                  chips v-model="Category" :items="ArticlesCategories" label="Category" >
                </v-combobox>  
                  <UserLookup v-if="$store.state.TemplateView" :UsersLookupArray="TemplateUsers"  :ModelProp="'Creator'" :RecordObj="editedItem" @UpdateUserLookupProp="UpdateUserLookupProp"
                    :FieldLabel="'Author'" :Rules="[$store.state.formrules.required]"
                    />           
                <v-switch v-if="!$store.state.UserisGuest && System.Guests_can_Social || System.Guests_can_Social && GroupData" v-model="TempGuestsIncluded"  :label="GroupData ? 'Include Non Team Members' : 'Include Guest Users'"/>
                <v-menu
                        v-model="PublishDatemenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        id="PublishDate">
                        <template v-slot:activator="{ on }">
                          <v-text-field                            
                            v-model="PublishDate"
                            label="Publish Date"
                            prepend-icon="mdi-calendar-month"
                            readonly
                            v-on="on"
                            id="PublishDate"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="PublishDate" @input="PublishDatemenu = false"></v-date-picker>
                      </v-menu>
                <v-checkbox label="Is Image Shy" v-model="ImageShy"/>
                <input
                v-if="!ImageShy && !$store.state.TemplateView"
            type="file"
            @change="onarticlecoverimageselect($event)"
            ref="coverimageinputter">
           
                </v-card-text>
                <v-layout class="justify-center">
                
          <v-img v-if="coverimagelocalurl && !$store.state.TemplateView" :src="coverimagelocalurl">
          </v-img>
           <v-img class="black" height="200" contain v-if="$store.state.TemplateView"									
              :src="coverimage ? coverimage : require('@/assets/ImageHolder.png')"									
              >
              <v-row style="left: 12px;position: absolute; bottom: 40px;width: 100%;height:50px;padding-top:10px;background: linear-gradient(180deg, rgba(222,221,221,0.5) 0%, rgba(222,221,221,0.5) 100%);">
          
                  <v-chip style="cursor: pointer;"  @click="ActivateGalleryDialog('SampleSiteArticleCoverIMG')" :class="$vuetify.theme.dark ? 'mx-3' : 'white mx-3'">Change</v-chip>
              </v-row>
        </v-img>
                </v-layout>
          <v-card-text>
              <ContentEditable @ActivateTagLinkDialog="ActivateTagLinkDialog"/>
            </v-card-text>
            <v-card-actions>    
            <v-textarea label="Caption" v-model="Caption" :rules="[$store.state.formrules.max150Chars]" />
            </v-card-actions>
            <v-card-actions>                
                <v-select multiple :items="SiteModerators" item-text="Full_Name" v-model="Moderators" return-object label="Select Moderators"/>                
            </v-card-actions>
            
            <v-card-actions>
                  <v-spacer></v-spacer>
                <v-btn @click="CancelEdit()" outlined color="orange">
                    Cancel
                </v-btn>
                <v-btn outlined color="green" @click="StoreArticle()">
                    Save
                </v-btn>
                
            </v-card-actions>
             <!-- <v-card-actions v-if="!$store.state.TemplateView">
              <TaggingComponent @SaveSingleTag="SaveSingleTag" :AppisDarkModeCard="AppisDarkModeCard" :record="FullArticleData" :TagLinkDialog="TagLinkDialog" />
            </v-card-actions> -->
        </v-card>
        </v-layout>

   </v-flex>
</v-layout>

</v-card>
</template>


<script>
import firebase from 'firebase';
import db from '@/main'
import format from 'date-fns/format'
import axios from 'axios'
import TaggingComponent from '@/components/SocialNetwork/TaggingComponent';
import ContentEditable from '@/components/SocialNetwork/ContentEditable';
import UserLookup from '@/components/General/UserLookup'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// import { quillEditor } from 'vue-quill-editor'

export default {
    props: ['caption','title','pubdatastring','CurrentImageShy','Currentarticlecontent','CurrentModerators','FullArticleData','GuestsIncluded','GroupData'
    ,'SiteModerators','CurrentImage','CurrentImageThumb','AppisDarkModeCard'],
        middleware: 'auth',
      components: {
    // quillEditor
    UserLookup,
    TaggingComponent,
    ContentEditable
      
        
  },
  
    data() {
        return {          
          coverimage: '',
          Category: '',
          ItemCategory: '',
          TempGuestsIncluded: false,
          TagLinkDialog: true,
          UsersArray: [],
          Caption: '',
          Moderators: [],
          PublishDate: '',
          PublishDatemenu: false,
          ArticleTitle: '',
          ImageShy: false,
        ImagelocalURL: '',
        ArticleContent: '',
        articlequil: false,
        snackbar: false,
            // content: '<h2>I am Example</h2>',
        editorOption: {
          // some quill options
        },
        articledialog: false,
                    inputRules: [
            v => !!v || 'This field is required',
            v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      UserRecord: {},
      articletitle: null,
        articlecontent: '',
        author: '',
        authorid: '',
        // userid: this.$store.state.user.id,
        grouparticles: [],
        groups: [],
        articleid: this.$route.params.id,
        content: null,
        selectedcoverimage: '',
        coverimagelocalurl: '',
        image: '',
        Youtubelink: '',
        HasImage: false,
        rules: {
          max150Chars: value => value.length < 151 || "Max. 150 characters",
        youtubeurl: value => {
            const pattern = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            return pattern.test(value) || "Not a Youtube Video Link.";
          },
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          },
          url: value => {
            const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); 
            return urlpattern.test(value) || "Invalid Link.";
          }
        },
       
            editedItem: {
                Name: null,
                description: null,
                url: null,
                logo: null,                
            },
            defaultItem: {
                Name: null,
                description: null,
                url: null,
                logo: null,                
            },
            ArticlesCategories: []    
        }
    },
    computed: {
      groupid(){
        return this.$route.params.id && !this.$store.state.TemplateView ? this.$route.params.id : ''
      },
      TemplateUsers(){
        return this.ActiveMarketTemplate && this.ActiveMarketTemplate.Users ? this.ActiveSuiteTemplate.Users.concat([this.userLoggedIn]) :
        this.ActiveSuiteTemplate && this.ActiveSuiteTemplate.Users ? this.ActiveSuiteTemplate.Users.concat([this.userLoggedIn]) : [this.userLoggedIn]
      },
      SuiteSocialNetwork(){
            return this.ActiveSuiteTemplate ? this.ActiveSuiteTemplate.SocialNetwork : ''
        },
      RouteName(){
          return this.$route.name === 'GroupArticle' || this.$route.name === 'MarketplaceTemplateGroupSingle' || this.$route.name === 'SuiteTemplateGroupSingle' ? this.GroupData.name+' Articles' : 
          this.SuiteSocialNetwork ? this.SuiteSocialNetwork.Name :
          this.ActiveMarketTemplate && this.ActiveMarketTemplate.TemplateProps && this.ActiveMarketTemplate.TemplateProps.Name ? this.ActiveMarketTemplate.TemplateProps.Name :
          this.System.Name
        },
      SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },      
      SocialItemInteractMethod(){
      return this.$store.state.SocialItemInteractMethod
      },
      SocialItemInteractMethodProp(){
          return this.$store.state.SocialItemInteractMethodProp
      },
      UserisTemplateOwner(){
        return this.$store.state.TemplateOwner
      }, 
      ActiveMarketTemplate(){
        return this.$store.state.ActiveMarketTemplate
      },
      ActiveSuiteTemplate(){
          return this.$store.state.ActiveSuiteTemplate
      },
      ContentCategoriesPath(){
        return this.$route.name === 'GroupArticleSingle' ? this.ContentRootPath.collection('groups').doc(this.$route.params.id).collection('ArticlesCategories') : 
        this.ContentRootPath.collection('ArticlesCategories')
      },
      ContentRootPath(){
        return this.ActiveMarketTemplate ? this.TemplateRootPath : db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid)
      },
      ContentColPath(){
        //quick tip here. Edit and New components reuqire collection to update, or add docs. thus, not interchangeable with CollectionRef on "feed" or "collection view"
        //the CollectionRef would add permission queries like for group aticles "where gourpid...etc"
        return this.ActiveMarketTemplate ? this.ContentRootPath.collection('samplesitearticles') : 
        this.$route.name === 'GroupArticle' ? this.ContentRootPath.collection('grouparticles') : this.ContentRootPath.collection('sitearticles')
      },
      TemplateRootPath(){
        return this.ActiveSuiteTemplate ? db.collection('SocialNetworks').doc(this.ActiveSuiteTemplate.id) :
        this.ActiveMarketTemplate ? db.collection('marketplacetemplates').doc(this.ActiveMarketTemplate.id) : ''
      },
        System(){
          return this.$store.state.SystemObj
        },
        userLoggedIn () {
          return this.$store.getters.user
        },
        ModeratorsIDStrings(){
          return this.Moderators.map(mod => {
            mod.id
          })
        },
        RelatedArticles () {
            return this.grouparticles.filter(article => {
                return article.articleid === this.articleid
            })
        },
      //         editor() {
      //   return this.$refs.myQuillEditor.quill
      // }
    },
    watch: {
        SocialItemInteractMethod(v){   
        let acceptedmethods = ['AssignSampleSiteArticleCoverIMG']   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created() {
      document.documentElement.scrollTop = 0;
      if(!this.$store.state.TemplateView){
        this.UserRecord = this.userLoggedIn
        this.authorid = this.UserRecord.id
        this.author = this.UserRecord.Full_Name
      }
      if(this.$store.state.TemplateView){
        this.UserRecord = this.userLoggedIn
        this.GetSiteArticlesCategories()
      }
      else if(this.$route.name !== 'GroupMeetup'){
        this.ArticlesCategories = this.System.ArticlesCategories
      }
      else{
        this.ArticlesCategories = this.GroupData.ArticlesCategories
      }
      this.GetProperties()      

    },
    
    methods: {
      UpdateUserLookupProp(Prop,Value,RecordObj){
            RecordObj[Prop] = Value
        },
      GetSiteArticlesCategories(){
        this.ContentCategoriesPath.onSnapshot(res => {
            const changes = res.docChanges();
              changes.forEach(change => {
                if (change.type === 'added') {
                  this.ArticlesCategories.push({
                    ...change.doc.data(),
                    id: change.doc.id
                  })
                }
              })
          })
      },
      ActivateGalleryDialog(prp){
        this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        this.$store.commit('setIMGProp',prp)
      },
      AssignSampleSiteArticleCoverIMG(){
        this.coverimage = this.SelectedImage.fileurl
       //this.RefreshDialog()
        this.$store.commit('setIMGProp','')
      },
      ActivateTagLinkDialog(boolean){
        this.TagLinkDialog = boolean  
      },
      taglink(){
        this.TagLinkDialog = true
      },
      SaveSingleTag(tagitem){
        console.log(tagitem)
        this.TagLinkDialog = false  
        document.execCommand("createLink", false, tagitem.taglocation);
      },
        CancelEdit(){
            this.$emit('StopEdit')
        },
        GetProperties(){
          if(this.FullArticleData.Category){
            this.Category = this.FullArticleData.Category
            this.ItemCategory = this.FullArticleData.Category
          }
          if(this.FullArticleData.coverimage){
            this.coverimage = this.FullArticleData.coverimage
          }
          this.Caption = this.caption
          
          if(this.FullArticleData.Creator){
            this.editedItem.Creator = this.FullArticleData.Creator
          }
          this.TempGuestsIncluded = this.GuestsIncluded
            this.ArticleTitle = this.title
            this.PublishDate = this.pubdatastring
            // console.log(this.PublishDate)
            if(typeof this.CurrentImageShy !== 'undefined'){
              this.ImageShy = this.CurrentImageShy
            }
            
            if(this.CurrentImage){
              this.coverimagelocalurl = this.CurrentImage
              this.HasImage = true
            }
            // console.log(this.SiteModerators)
             //console.log(this.SiteModerators,this.CurrentModerators)
            this.Moderators = this.CurrentModerators.map(moderator => {
                let fullobj = this.SiteModerators.find(obj => obj.id === moderator)
                return fullobj
            }).filter(mod => {
              return mod && mod.id
            })
            let Moderator = {
              Full_Name: this.userLoggedIn.Full_Name,
              Name: this.userLoggedIn.Name,
              Surname: this.userLoggedIn.Surname,
              ModerationPermissions: this.userLoggedIn.ModerationPermissions ? this.userLoggedIn.ModerationPermissions : [],
              id: this.userLoggedIn.id
            }
            if(!this.Moderators.find(obj => obj.id === Moderator.id)){
               this.Moderators.push(Moderator)
            }
           
            let elementid = 'NewBlogValue'            
            setTimeout(() => {
                let articlecontentelmnt = document.getElementById(elementid)
                articlecontentelmnt.innerHTML = this.Currentarticlecontent
            }, 300);
            
        },
      
   DateFormatter(date){
      if(date){
      let yearstring = date.split('-')[0]
        let monthstring = date.split('-')[1]
        let daystring = date.split('-')[2]
        let yearnumber = Number(yearstring)
        let monthnumber = Number(monthstring)
        let daynumber = Number(daystring)
        return new Date(yearnumber, monthnumber-1, daynumber)
        }
      else{
        return null
      }
   },
        onarticlecoverimageselect(event) {
      this.selectedcoverimage = event.target.files[0]
      this.HasImage = false
      this.coverimagelocalurl = URL.createObjectURL(this.selectedcoverimage)
    },
        PrepareUpdateArticleCoverImageThumbnail(file,NewArticle,storagepath){
        let filename = file.name.split('.')[0]+'_'+file.size+'.'+file.name.split('.')[1]
        file.tmpsrc = URL.createObjectURL(file)
              //this.OutboundPhotosforUpload.push(file)
              var img = document.createElement("IMG");
                img.setAttribute('width',150)
                img.setAttribute('src',file.tmpsrc)
                document.body.appendChild(img)
                let vm = this
                img.onload = function() {
                var c = document.createElement("canvas");
                var ctx = c.getContext("2d");
                var canvasRatio = img.naturalHeight / img.naturalWidth
                c.width = 1000
                c.height = c.width*canvasRatio
                ctx.drawImage(img, 0, 0, c.width, c.height);
                c.toBlob(blob => {
                  let blobfile = new File([blob], filename, {
              type: file.type,
            });
            console.log(blobfile)
            var storageRef = firebase.storage().ref(storagepath+'_thumb')
                document.body.removeChild(img)
                var uploadTask = storageRef.put(blobfile)
                uploadTask
                  .then(snapshot => snapshot.ref.getDownloadURL())
                    .then((thumburl) => {
                      console.log(thumburl)
                      NewArticle.coverimage = thumburl
                      NewArticle.coverimageThumbURL = thumburl
                      NewArticle.CoverStorageRef = storagepath
                      console.log(NewArticle.post)
                      console.log(NewArticle)
                      vm.ContentColPath.set(NewArticle).then(doc => {
                          vm.$emit('StopEdit')
                      })
                      
                        vm.CancelNewArticleDialog()
                      // vm.UpdateArticleCoverImage(file,thumburl,NewArticle)
                      })
                      
              })
      }
      },

        StoreArticle(){
          console.log('this.UserRecord',this.UserRecord)
          let Creator = {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id,Name: this.UserRecord.Name,Surname: this.UserRecord.Surname}
            let MaskedUser = ''
           if(this.$store.state.TemplateView && this.editedItem.Creator){
              Creator = {Full_Name: this.editedItem.Creator.Full_Name,id: this.editedItem.Creator.id,Name: this.editedItem.Creator.Name,Surname: this.editedItem.Creator.Surname}
              MaskedUser = {Full_Name: this.UserRecord.Full_Name,id: this.UserRecord.id,Name: this.UserRecord.Name,Surname: this.UserRecord.Surname}
            }
          let vm = this
          vm.$emit('ActivateProcessing',true)
           if(vm.Category && !vm.Category.ID){
            let length = vm.ArticlesCategories.length
            let int = 1000001+length
            let newcat = {
              ID: int,
              Name: vm.Category
            }
            vm.ItemCategory = newcat
            this.ContentCategoriesPath.add(newcat)
          }
          else if(vm.Category && vm.Category.ID){
            vm.ItemCategory = vm.Category
          }
          let routepath = ''
          let routeprop = ''
          let storagepath = ''
          let docid = this.$route.params.id
           if(this.ActiveMarketTemplate){
              routepath = '/MarketplaceTemplate/'+this.$route.params.id+'/Article/'
              routeprop = 'id'
              docid = this.$route.params.slug
            }
            else if(this.ActiveSuiteTemplate){
              routepath = '/Your-Domain/'+this.$route.params.id+'/Social-Network/Article/'
              routeprop = 'id'
              docid = this.$route.params.slug
            }
          else if(this.$route.params.id){
            routepath = '/Group-Article/'+this.$route.params.id+'/Article/'
            routeprop = 'title'
            docid = this.$route.params.slug
          }
          else{
            routepath = '/Article/'
            routeprop = 'id'
          }
        let postelmnt = document.getElementById('NewBlogValue')
        console.log(postelmnt)
        let postinput = postelmnt.innerHTML     
        let ModeratorRolesObject = {}
              let ModeratorRolesArray= []
              this.Moderators.map(mod => {
                ModeratorRolesObject[mod.id] = true
                ModeratorRolesArray.push(mod.id)
              })
            let NewArticle = {
              Likes: [],
              Shares: [],
              tags: [],
              title: this.ArticleTitle,
              Creator: {Full_Name: Creator.Full_Name,id: Creator.id},          
              Creatorid: Creator.id,
              author: Creator.Full_Name,
              authorid: Creator.id,
              description: postinput,
              createdon: new Date(),
              PublishDate: this.DateFormatter(this.PublishDate),
              Comments: [],
              ImageShy: this.ImageShy,
              PublishStatus: 'Draft',
              Moderators: this.Moderators,
              moderatorrolesarrayDBRules: ModeratorRolesObject,
              moderatorrolesarrayQuery: ModeratorRolesArray,
              caption: this.Caption,
              GuestsIncluded: this.TempGuestsIncluded
            }          
            if(MaskedUser){
              NewArticle.MaskedUser = MaskedUser
              NewArticle.MaskedUserid = MaskedUser.id
            } 
            if(this.groupid){
              NewArticle.groupid = this.groupid
            }   
            
            if(!NewArticle.groupid && this.userLoggedIn && this.userLoggedIn.Company){
              NewArticle.Company = this.userLoggedIn.Company
              NewArticle.Companyid = this.userLoggedIn.Companyid
            }  
            if(vm.ItemCategory){
              NewArticle.Category = vm.ItemCategory
            }
            if(Creator.Profile_Photo){
              NewArticle.creatorimg = Creator.Profile_Photo
            }       
        this.$store.dispatch('CreateSearchTitle',NewArticle.title).then(searchtitle => {
        NewArticle.titleQuery = searchtitle
            if(this.selectedcoverimage && this.ArticleTitle && postinput && !this.$store.state.TemplateView){
             
            if(this.HasImage === false){
              let filename = this.selectedcoverimage.name.split('.')[0]+'_'+this.selectedcoverimage.size+'.'+this.selectedcoverimage.name.split('.')[1]
              if(this.$route.params.id){
              storagepath = 'GroupArticles/'+this.$route.params.id+'/CoverImage/'+docid+'/'+new Date()+'/'+filename
              }
              else{
                storagepath = 'SiteBlogs/'+this.$route.params.id+'/CoverImage/'+new Date()+'/'+filename
              }
              this.PrepareUpdateArticleCoverImageThumbnail(this.selectedcoverimage,NewArticle,storagepath)
              // this.UpdateArticleCoverImage(this.selectedcoverimage).then(function(result) {
              //   if(result){
              //       NewArticle.coverimage = result
              //      db.collection('sitearticles').doc(vm.$route.params.id).set(NewArticle).then(doc => {
              //          vm.$emit('StopEdit')
              //      })
              //      console.log(NewArticle.post)
              //       vm.CancelNewArticleDialog()
              //   }          
              // })
            }
            else{
              NewArticle.coverimage = this.CurrentImage
              NewArticle.coverimageThumbURL = this.CurrentImageThumb
              if(MaskedUser){
                NewArticle.MaskedUser = MaskedUser
                NewArticle.MaskedUserid = MaskedUser.id
              }
              this.ContentColPath.doc(docid).set(NewArticle).then(doc => {
                      vm.$emit('StopEdit')
                  })
            }
              
            }
            else if(this.ImageShy && this.ArticleTitle && postinput || this.$store.state.TemplateView){
              
            let docref = this.ContentColPath.doc(docid)
              if(this.$store.state.TemplateView){
                NewArticle.coverimage = this.coverimage
                NewArticle.PublishDate = new Date()
              }
              docref.set(NewArticle).then(doc => {
                vm.CancelEdit()
                  })
                  //console.log(NewArticle.post) 
            }
            else if(!this.selectedcoverimage && this.ArticleTitle && postinput && this.HasImage === false){
                alert('You have to upload an image')
            }
            else if(!this.selectedcoverimage && !this.ArticleTitle && postinput && this.HasImage === false){
                alert('You have to upload an image, and insert a title')
            }
            else if(!this.selectedcoverimage && !this.ArticleTitle && !postinput){
                alert('There is nothing to post!')
            }
            else if(!this.selectedcoverimage && this.ArticleTitle && !postinput){
                alert('There is no cover image, or post content!')
            }
            else if(this.selectedcoverimage && !this.ArticleTitle && postinput){
                alert('You have to insert a title')
            }
            else if(this.selectedcoverimage && !this.ArticleTitle && !postinput){
                alert('You have to insert a title, and content')
            }
            else if(this.selectedcoverimage && this.ArticleTitle && !postinput){
                alert('You have to insert content')
            }
        })
        
      
        },

        UpdateArticleCoverImage(picturefile){
      let vm = this
      return new Promise(function(resolve, reject) {
      var storageRef = firebase.storage().ref('Group/' + 'ArticleCover/'+picturefile.name);
      var uploadTask = storageRef.put(picturefile);
      uploadTask
      .then(snapshot => snapshot.ref.getDownloadURL())
        .then((url) => {
          
          
          resolve(url)
              })
                
      })
    },
        CancelNewArticleDialog(){
            this.ArticleTitle = ''
            this.selectedcoverimage = ''
        },
      IntranetViewToggle(){
        this.$emit('IntranetViewToggle',true)
      },
      FocusedViewToggle(){
        this.$emit('FocusedViewToggle',false)
      },
            getUserInformation() {
                db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('users').doc(this.UserRecord.id).onSnapshot(snapshot => {
          // this.UpdateRequestStatus()
          var userdata = snapshot.data()
        this.authorid = userdata.id
      
        this.author = userdata.Name+' '+userdata.Surname
console.log('this is user name man '+this.author)
      

        })
            },
        
          
      }
      
    }
// }
</script>
<style>
.tabsinner {
    background-color: #f8f8f8;
    color: #575757;
}
.Grouptitle {
color: #048abf;
margin-left: 0.5em
}
.Groupdescription {
color: #70cbf3;

}
.Image {

margin-left: 0.5em
}
h2{
  color: 'primary';
}
    
</style>